import { LocalizationService } from '@abp/ng.core';
import { inject } from '@angular/core';
import { injectToastService } from '@ral/utils:core/toast';
import { MutationOptions } from '@tanstack/angular-query-experimental';

export type AptMutationOptions<InputDto, ResponseDto> = Partial<
    Pick<
        MutationOptions<ResponseDto, Error, InputDto>,
        'onSuccess' | 'onMutate' | 'onError' | 'onSettled' | 'retry' | 'retryDelay'
    >
> & {
    i18n?: {
        errorToastTitle?: string;
        errorToastMessage?: string;
    };
};

export const aptMutationDefaultErrorHandler = (
    options: {
        i18n?: {
            errorToastTitle?: string;
            errorToastMessage?: string;
        };
    },
    localization = inject(LocalizationService)
) => {
    const toastService = injectToastService();
    return (error: Error) => {
        if (error.message === 'Unauthorized') {
            toastService.error({
                title: error.message,
            });
        } else {
            toastService.error({
                title: options?.i18n?.errorToastTitle ? localization.instant(options?.i18n?.errorToastTitle) : 'Error',
                message: options?.i18n?.errorToastMessage
                    ? localization.instant(options?.i18n?.errorToastMessage)
                    : error.message,
            });
        }
    };
};
